import { scheduleQuickstartReducer } from './services/schedule.service';

export const SCHEDULE_QUICKSTART_REDUCERS: any = {
  scheduleProgramming: scheduleQuickstartReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/schedule-quickstart.store.ts